export function removeParam(parameter) {
  let url = document.location.href;
  let urlparts = url.split('?');

  if (urlparts.length >= 2) {
    let urlBase = urlparts.shift();
    let queryString = urlparts.join("?");

    let prefix = encodeURIComponent(parameter) + '=';
    let pars = queryString.split(/[&;]/g);
    for (let i = pars.length; i-- > 0;)
      if (pars[i].lastIndexOf(prefix, 0) !== -1)
        pars.splice(i, 1);
    url = urlBase + '?' + pars.join('&');

    window.history.pushState({url: url}, document.title, url); // added this line to push the new url directly to url bar .
  }
  return url;
}


export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// WEBPACK FOOTER //
// ./js/utils.js